"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserProfile = exports.UserProfileProperties = void 0;
var types_1 = require("../types");
var enums_1 = require("./enums");
exports.UserProfileProperties = ['about', 'birth_date', 'spoken_languages', 'studying_subjects', 'education_schools', 'education_docs', 'teaching_subjects', 'social_accounts', 'work_experience', 'version', 'verification_status', 'verification_comment', 'verification_sent_at', 'verified_at', 'skype', 'telegram'];
var UserProfileDateProperties = ['verification_sent_at', 'verified_at'];
var UserProfile = /** @class */function (_super) {
  __extends(UserProfile, _super);
  function UserProfile(values) {
    if (values === void 0) {
      values = {};
    }
    var _this = _super.call(this, values, exports.UserProfileProperties) || this;
    if ('spoken_language' in values) {
      // TODO spoken_language -> расшифровать language
      // TODO spoken_language -> расшифровать level
    }
    if ('studying_subjects' in values) {
      // TODO studying_subjects -> расшифровать subject
      // TODO studying_subjects -> расшифровать level
    }
    if ('teaching_subjects' in values) {
      // TODO teaching_subjects -> расшифровать subject
    }
    if ('social_accounts' in values) {
      // TODO social_accounts -> ???
    }
    if ('work_experience' in values) {
      // TODO work_experience -> ???
    }
    // преобразование дат
    _this.formatDates(UserProfileDateProperties);
    return _this;
  }
  Object.defineProperty(UserProfile.prototype, "defaultProperties", {
    get: function () {
      return {
        spoken_languages: [],
        studying_subjects: [],
        education_schools: [],
        education_docs: [],
        teaching_subjects: [],
        social_accounts: [],
        work_experience: [],
        verification_status: enums_1.UserProfileVerificationEnum.not_verified
      };
    },
    enumerable: false,
    configurable: true
  });
  return UserProfile;
}(types_1.Assignable);
exports.UserProfile = UserProfile;
